import * as React from 'react';
import { Title } from '../../components/Title';
import { EActiveFlow } from '../../types/flow';
import { EHeadingType } from '../../types/headingType';
import { ESentEmailType } from '../../types/sentEmail';
import { EActiveView } from '../../types/view';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var getThereIsAnAccountHeadingType = function getThereIsAnAccountHeadingType() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: ["\u0423 \u0432\u0430\u0441 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u0430\u043A\u043A\u0430\u0443\u043D\u0442,", /*#__PURE__*/_jsx("br", {}), "\u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0443\u0439\u0442\u0435\u0441\u044C"]
  });
};
export function TitleContainer(_ref) {
  var currentView = _ref.currentView,
    viewData = _ref.viewData,
    flow = _ref.flow,
    indent = _ref.indent;
  var title = React.useMemo(function () {
    switch (currentView) {
      case EActiveView.AuthenticationRegistration:
        switch (viewData === null || viewData === void 0 ? void 0 : viewData.headingType) {
          case EHeadingType.ThereIsAnAccount:
            return getThereIsAnAccountHeadingType();
          case EHeadingType.NewOfferForm:
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: ["\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B", /*#__PURE__*/_jsx("br", {}), "\u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435"]
            });
        }
        if (!flow) {
          return 'Вход и регистрация';
        }
        return flow === EActiveFlow.Authentication ? 'Вход' : 'Регистрация';
      case EActiveView.AccountSelect:
      case EActiveView.ConfirmSelectedAccount:
      case EActiveView.TokenExpiredError:
      case EActiveView.AccountSelectError:
        return 'Вход';
      case EActiveView.PhoneAuth:
        {
          switch (viewData === null || viewData === void 0 ? void 0 : viewData.headingType) {
            case EHeadingType.AdvancedFiltersAuthPermission:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B", /*#__PURE__*/_jsx("br", {}), "\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435", /*#__PURE__*/_jsx("br", {}), "\u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432"]
              });
            case EHeadingType.PhoneAuthPermission:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B", /*#__PURE__*/_jsx("br", {}), "\u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u043E\u043C\u0435\u0440", /*#__PURE__*/_jsx("br", {}), "\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"]
              });
            case EHeadingType.InformationPermission:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B", /*#__PURE__*/_jsx("br", {}), "\u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C", /*#__PURE__*/_jsx("br", {}), "\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E"]
              });
            case EHeadingType.BuyCommercialAnalyticsPermission:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u0445\u043E\u0434 \u0438\u043B\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F", /*#__PURE__*/_jsx("br", {}), "\u0434\u043B\u044F \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u043E\u0442\u0447\u0451\u0442\u0430"]
              });
            case EHeadingType.ThereIsAnAccount:
              return getThereIsAnAccountHeadingType();
            case EHeadingType.SelectRealtor:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u043E\u0439\u0434\u0438\u0442\u0435,", /*#__PURE__*/_jsx("br", {}), "\u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u043E\u0431\u0440\u0430\u0442\u044C \u0440\u0438\u0435\u043B\u0442\u043E\u0440\u0430"]
              });
            case EHeadingType.NewOfferForm:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B", /*#__PURE__*/_jsx("br", {}), "\u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435"]
              });
            case EHeadingType.SaveSearchPermission:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u043E\u0439\u0434\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B", /*#__PURE__*/_jsx("br", {}), "\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043F\u043E\u0438\u0441\u043A"]
              });
            default:
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: ["\u0412\u043E\u0439\u0442\u0438 \u0438\u043B\u0438", /*#__PURE__*/_jsx("br", {}), "\u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F"]
              });
          }
        }
      case EActiveView.PhoneAuthValidateSms:
      case EActiveView.TwoFactorPhoneValidateSms:
        return 'Подтверждение входа';
      case EActiveView.PhoneAuthValidateCall:
      case EActiveView.TwoFactorPhoneValidateCall:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: ["\u0417\u0432\u043E\u043D\u0438\u043C \u0432\u0430\u043C, \u0432\u0432\u0435\u0434\u0438\u0442\u0435", /*#__PURE__*/_jsx("br", {}), "4 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 \u0446\u0438\u0444\u0440\u044B \u043D\u043E\u043C\u0435\u0440\u0430"]
        });
      case EActiveView.Agreement:
        return 'Дайте согласие, чтобы продолжить';
      case EActiveView.ConfirmPhone:
        return 'Подтверждение телефона';
      case EActiveView.EmailSent:
        if (viewData.type === ESentEmailType.Registration) {
          return 'Завершение регистрации';
        } else {
          return 'Восстановление пароля';
        }
      case EActiveView.TwoFactorWithPhone:
      case EActiveView.TwoFactorWithEmail:
        return 'Подтверждение входа';
      case EActiveView.TwoFactorAttemptsExhausted:
        return 'Ошибка входа';
      case EActiveView.Restore:
        return 'Восстановление пароля';
      case EActiveView.SocialCreate:
        return 'Завершение регистрации';
      case EActiveView.SocialMerge:
        return 'Объединение аккаунтов';
      case EActiveView.RememberedAccountsSelect:
        return 'Выберите аккаунт';
      default:
        return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentView, flow]);
  if (!title) {
    return null;
  }
  return /*#__PURE__*/_jsx(Title, {
    indent: indent,
    children: title
  });
}